import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import { Carousel } from 'react-responsive-carousel';
import {fieldObjectSectionStyle} from "../../helpers/graphQLShortcuts";
import {fieldObjectSectionStyleCss} from "../../helpers/createStyles";
import {filterHTML, filterResource} from "../../helpers/filters";
import './QuoteCarousel.scss';

interface Data {
    paragraphById: {
        fieldVarDisplayType: string;
        fieldVarItemsPerRow: string;
        fieldInnerCards: Array<{targetId: number}>;
        fieldInnerSectionHeader: Array<{
            entity: Array<{
                fieldTxtHeadline: string;
                fieldHtmlBody: Array<{
                    value: string;
                    format: string;
                    processed: string;
                }>;
                fieldVarTextAlignment: string;
            }>
        }>;
        fieldInnerQuotesToInclude: Array<{
            targetRevisionId: string;
            entity: Array<{
                fieldQuoteByName: string;
                fieldHtmlBody: Array<{
                    value: string;
                    format: string;
                    processed: string;
                }>;
                fieldObjectImgMedia: Array<{
                    entity: Array<{
                        fieldMediaImage: Array<{
                            width: string;
                            height: string;
                            url: string;
                            targetId: string;
                            alt: string;
                            title: string;
                        }>;
                    }>;
                }>;
            }>
        }>;
        fieldSectionStyleQuote: Array<{entity: Array}>;
    }
}

class QuoteCarouselQuery extends Query<Data, {id: string}> {}

const GET_CARDS = gql`
query paragraphById($id: String!) {
  paragraphById:paragraphRevisionById(id: $id) {
    ... on ParagraphComponentQuote {
      fieldSectionStyleQuote {
          ${fieldObjectSectionStyle}       
      }
      fieldInnerQuotesToInclude {
        targetRevisionId
          entity {
            ... on Paragraph {
              ...on ParagraphInnerQuoteItem {
                fieldQuoteByName
                fieldHtmlBody {
                  value
                  format
                  processed
                }
                fieldObjectImgMedia {
                    entity {
                      ... on MediaImage {
                        fieldMediaImage {
                          width
                          height
                          url
                          alt
                          title
                        }
                      }
                  }
                }
              }
            }
          }
      }
    }
  }
}

`;

const QuoteCarousel = ({id, markComponentLoadedAs}) => (
    <QuoteCarouselQuery asyncMode query={GET_CARDS} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;

            const styles = fieldObjectSectionStyleCss(field.fieldSectionStyleQuote, `${field.fieldVarDisplayType} carousel--items-${field.fieldVarItemsPerRow}`);

            // if (!styles.css.padding) {
            //     styles.css.padding = '80px 20px';
            // }

            markComponentLoadedAs(id, true);

            return (
                <div className={`quoteCarousel${styles.classNames}`} style={styles.css} id={styles.id}>
                    {styles.childBackground.isActive && (
                        <div style={styles.childBackground.css}/>
                    )}
                    <div className="container">
                        {field.fieldInnerQuotesToInclude && (
                            <Carousel showArrows emulateTouch useKeyboardArrows showThumbs={false} showStatus={false} showIndicators={false}>
                                {field.fieldInnerQuotesToInclude.map(component => (

                                    <div className="quoteCarouselItem" key={`quoteCarouselItem_${component.targetRevisionId}`}>
                                        {component.entity && component.entity.fieldObjectImgMedia && component.entity.fieldObjectImgMedia.entity && component.entity.fieldObjectImgMedia.entity.fieldMediaImage && component.entity.fieldObjectImgMedia.entity.fieldMediaImage.url && (
                                            <div className="quoteCarousel__image" key={`image_${component.entity.fieldObjectImgMedia.entity.fieldMediaImage.targetId}`}
                                                 style={{backgroundImage: `url(${filterResource(component.entity.fieldObjectImgMedia.entity.fieldMediaImage.url)})`}} />
                                        )}

                                        <div className="quoteCarousel__textModule">
                                        {component.entity && component.entity.fieldHtmlBody && component.entity.fieldHtmlBody.processed && (
                                            // eslint-disable-next-line react/no-danger
                                            <div className="quoteCarousel__quote" dangerouslySetInnerHTML={{__html: filterHTML(component.entity.fieldHtmlBody.processed)}}/>
                                        )}

                                        {component.entity && component.entity.fieldQuoteByName ? (
                                            <p className="quoteCarousel__cite">— {component.entity.fieldQuoteByName}</p>
                                        ) : null}

                                        </div>
                                    </div>

                                ))}
                            </Carousel>
                        )}
                    </div>
                </div>
            );
        }}
    </QuoteCarouselQuery>
);

QuoteCarousel.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    handleLoadedComponents: PropTypes.func.isRequired
};

export default QuoteCarousel;



// WEBPACK FOOTER //
// ./frontend/components/QuoteCarousel/QuoteCarousel.jsx